import { Injectable } from '@angular/core';
import { AdminValetActivityService } from '../services/admin-valet-activity.service';
import { Delivery, DeliveryStatus } from '../models/delivery.schema';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeliveryService } from '../services/delivery.service';
import { ExpertDeliveryRulesService } from '../services/expert-delivery-rules.service';
import { ExpertDeliveryRulesSchema } from '../models/expert-delivery-rules.schema';
import { compareValues } from './operator.helper';
import { plainToClass } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class AdminValetActivityHelpherService {

  constructor(
    private adminValetActivityService: AdminValetActivityService,
    private _snackBar: MatSnackBar,
    private deliveryService: DeliveryService,
    private expertDeliveryRulesService: ExpertDeliveryRulesService,
  ) {}

  async createOrUpdateActivities(delivery: Delivery){
    try {

      if(delivery.expert?.id){  
        let filtered = {};
        const deliveryDate = new Date(delivery.deliveryDate);
        const normalizedDeliveryDate = deliveryDate.getFullYear() + '-' + ('0' + (deliveryDate.getMonth() + 1)).slice(-2) + '-' + ('0' + deliveryDate.getDate()).slice(-2);
        let maxOrder = 0;
        let data = await this.adminValetActivityService.findMaxOrder(delivery.expert.id, normalizedDeliveryDate);
        maxOrder = data.maxOrder;
  
        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(delivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        const activityData = await this.adminValetActivityService.getAdminValetActivity(filtered);
        const activitiesWithDeliveryId = activityData?.activities || [];
  
        if(!activitiesWithDeliveryId.length) {
          if(delivery.serviceType.toLowerCase() === "sales" && delivery.ddtNumber){
            delete filtered["Delivery.id"];
            filtered['AdminValetActivity.ddtNumber'] = Number(delivery.ddtNumber);
            const data = await this.adminValetActivityService.getAdminValetActivity(filtered);
            const activitiesWithSameDdtNumber = data?.activities || [];
            let activityArray: any[] = [];
            if(activitiesWithSameDdtNumber.length > 0){
              let deletedOrder: number;
              let deliveryActivities = activitiesWithSameDdtNumber.filter((activity) => activity.activityType.toLowerCase() === 'delivery');
              for(let deliveryActivity of deliveryActivities){
                deletedOrder = deliveryActivity.order;
                await this.adminValetActivityService.deleteActivity(deliveryActivity.id);
              }
              activityArray = await this.buildActivityArraySalesCase(delivery, maxOrder, deletedOrder);
            } else {
              activityArray = await this.buildActivityArray(delivery, maxOrder);
            }
            await this.adminValetActivityService.create(activityArray);
          } else {
            let activityArray: any[] = await this.buildActivityArray(delivery, maxOrder);
            await this.adminValetActivityService.create(activityArray);
          }
        }
      }
      return;
    } catch (error) {
      this.showSnackBar("Something went wrong");
      console.log(error);
    }
  }

  /*
  async createOrUpdateActivitiesNewFunction(previousDelivery: Delivery, delivery: Delivery){
    try {
      let filtered = {};
      const deliveryDate = new Date(delivery.deliveryDate);
      const normalizedDeliveryDate = deliveryDate.getFullYear() + '-' + ('0' + (deliveryDate.getMonth() + 1)).slice(-2) + '-' + ('0' + deliveryDate.getDate()).slice(-2);
      const expertChanged = delivery?.expert?.id !== previousDelivery?.expert?.id;
      const expertAssigned = delivery?.expert?.id && (previousDelivery?.expert?.id == null || delivery?.expert.id === previousDelivery?.expert?.id);
      let maxOrder = 0;
      let data = await this.adminValetActivityService.findMaxOrder(delivery?.expert?.id, normalizedDeliveryDate);
      maxOrder = data.maxOrder;

      if(expertAssigned){  
        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(delivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        let activitiesWithDeliveryId = await this.adminValetActivityService.getAdminValetActivity(filtered);

        if(!activitiesWithDeliveryId.length) {
          console.log("Expert Assignment");
          if(delivery.serviceType.toLowerCase() === "sales" && delivery.ddtNumber){
            delete filtered["Delivery.id"];
            filtered['AdminValetActivity.ddtNumber'] = Number(delivery.ddtNumber);
            let activitiesWithSameDdtNumber = await this.adminValetActivityService.getAdminValetActivity(filtered);
            let activityArray: any[] = [];
            if(activitiesWithSameDdtNumber.length > 0){
              let deliveryActivities = activitiesWithSameDdtNumber.filter((activity) => activity.activityType.toLowerCase() === 'delivery');
              let deletedOrder: number;
              for(let deliveryActivity of deliveryActivities){
                deletedOrder = deliveryActivity.order;
                await this.adminValetActivityService.deleteActivity(deliveryActivity.id);
              }
              activityArray = await this.buildActivityArraySalesCase(delivery, maxOrder, deletedOrder);
            } else {
              activityArray = await this.buildActivityArray(delivery, maxOrder);
            }
            await this.adminValetActivityService.create(activityArray);
          } else {
            let activityArray: any[] = await this.buildActivityArray(delivery, maxOrder);
            await this.adminValetActivityService.create(activityArray);
          }
        }
        return;
      } else if(expertChanged) {
        console.log("EXPERT HAS BEEN CHANGED");
        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(previousDelivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        await this.adminValetActivityService.deleteAssignedActivities(filtered);

        let maxOrder = 0;
        let data = await this.adminValetActivityService.findMaxOrder(delivery.expert.id, normalizedDeliveryDate);
        maxOrder = data.maxOrder;

        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(delivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        let activitiesWithDeliveryId = await this.adminValetActivityService.getAdminValetActivity(filtered);

        if(!activitiesWithDeliveryId.length) {
          let activityArray: any[] = await this.buildActivityArray(delivery, maxOrder);
          await this.adminValetActivityService.create(activityArray);
        }

        return;
      }
    } catch (error) {
      this.showSnackBar("Something went wrong");
      console.log(error);
    }
  }
  */

  async createOrUpdateActivitiesNewFunction(delivery: Delivery){
    try {

      if(delivery.status === DeliveryStatus.canceled || delivery?.expert === null || delivery?.expert?.id === null) {
        console.log("Delivery is canceled or expert is null or expert id is null");
        return;
      }

      const existingDelivery = plainToClass(Delivery, await this.deliveryService.getOne(delivery.id));
      const isExpertChanged = delivery?.expert?.id !== existingDelivery?.expert?.id;
      const isExpertAssigned = delivery?.expert?.id && (existingDelivery?.expert?.id == null || delivery?.expert.id === existingDelivery?.expert?.id);
      let maxOrder: number = 0;
      const deliveryDate = new Date(delivery.deliveryDate);
      const normalizedDeliveryDate = deliveryDate.getFullYear() + '-' + ('0' + (deliveryDate.getMonth() + 1)).slice(-2) + '-' + ('0' + deliveryDate.getDate()).slice(-2);
      let data = await this.adminValetActivityService.findMaxOrder(delivery?.expert?.id, normalizedDeliveryDate);
      maxOrder = data.maxOrder;
      let filtered = {};

      if(isExpertAssigned){  
        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(delivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        const data = await this.adminValetActivityService.getAdminValetActivity(filtered);
        const activitiesWithDeliveryId = data?.activities || [];

        if(!activitiesWithDeliveryId.length) {
          console.log("Expert Assignment");
          if(delivery.serviceType.toLowerCase() === "sales" && delivery.ddtNumber){
            delete filtered["Delivery.id"];
            filtered['AdminValetActivity.ddtNumber'] = Number(delivery.ddtNumber);
            const data = await this.adminValetActivityService.getAdminValetActivity(filtered);
            const activitiesWithSameDdtNumber = data?.activities || [];
            let activityArray: any[] = [];
            if(activitiesWithSameDdtNumber.length > 0){
              let deliveryActivities = activitiesWithSameDdtNumber.filter((activity) => activity.activityType.toLowerCase() === 'delivery');
              let deletedOrder: number;
              for(let deliveryActivity of deliveryActivities){
                deletedOrder = deliveryActivity.order;
                await this.adminValetActivityService.deleteActivity(deliveryActivity.id);
              }
              activityArray = await this.buildActivityArraySalesCase(delivery, maxOrder, deletedOrder);
            } else {
              activityArray = await this.buildActivityArray(delivery, maxOrder);
            }
            await this.adminValetActivityService.create(activityArray);
          } else {
            let activityArray: any[] = await this.buildActivityArray(delivery, maxOrder);
            await this.adminValetActivityService.create(activityArray);
          }

        }

        let newFilter = {};
        newFilter['AdminValetActivity.expertId'] = (existingDelivery.expert.id);
        newFilter['AdminValetActivity.completed'] = 0;
        newFilter['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        let activities = await this.adminValetActivityService.getAllWithDeliveryDateOrder(null, null, {}, newFilter);
        await this.changeActivityOrderAccordingTime(activities?.activities);

        return;
      } else if(isExpertChanged) {
        console.log("EXPERT HAS BEEN CHANGED");
        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(existingDelivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        await this.adminValetActivityService.deleteAssignedActivities(filtered);

        let maxOrder = 0;
        let data = await this.adminValetActivityService.findMaxOrder(delivery.expert.id, normalizedDeliveryDate);
        maxOrder = data.maxOrder;

        filtered['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        filtered['AdminValetActivity.expertId'] = Number(delivery.expert?.id);
        filtered['Delivery.id'] = Number(delivery.id);
        const activityData = await this.adminValetActivityService.getAdminValetActivity(filtered);
        const activitiesWithDeliveryId = activityData?.activities || [];

        if(!activitiesWithDeliveryId.length) {
          if(delivery.serviceType.toLowerCase() === "sales" && delivery.ddtNumber){
            delete filtered["Delivery.id"];
            filtered['AdminValetActivity.ddtNumber'] = Number(delivery.ddtNumber);
            const data = await this.adminValetActivityService.getAdminValetActivity(filtered);
            const activitiesWithSameDdtNumber = data?.activities || [];
            let activityArray: any[] = [];
            if(activitiesWithSameDdtNumber.length > 0){
              let deliveryActivities = activitiesWithSameDdtNumber.filter((activity) => activity.activityType.toLowerCase() === 'delivery');
              let deletedOrder: number;
              for(let deliveryActivity of deliveryActivities){
                deletedOrder = deliveryActivity.order;
                await this.adminValetActivityService.deleteActivity(deliveryActivity.id);
              }
              activityArray = await this.buildActivityArraySalesCase(delivery, maxOrder, deletedOrder);
            } else {
              activityArray = await this.buildActivityArray(delivery, maxOrder);
            }
            await this.adminValetActivityService.create(activityArray);
          } else {
            let activityArray: any[] = await this.buildActivityArray(delivery, maxOrder);
            await this.adminValetActivityService.create(activityArray);
          }
        }

        let newFilter = {};
        newFilter['AdminValetActivity.expertId'] = (existingDelivery.expert.id);
        newFilter['AdminValetActivity.expertId'] = (existingDelivery.expert.id);
        newFilter['AdminValetActivity.completed'] = 0;
        newFilter['AdminValetActivity.deliveryDate'] = { operator: 'between', values: [normalizedDeliveryDate, normalizedDeliveryDate] };
        let activities = await this.adminValetActivityService.getAllWithDeliveryDateOrder(null, null, {}, newFilter);
        await this.changeActivityOrderAccordingTime(activities?.activities);
        
        return;
      }
    } catch (error) {
      this.showSnackBar("Something went wrong");
      console.log(error);
    }
  }

  async buildActivityArraySalesCase(delivery, order: number, deletedOrder: number){
    let activityArray: any[] = [];
    activityArray.push({
      "expert": delivery.expert.id,
      "activityType": "pickup",
      "delivery": delivery.id,
      "deliveryDate": delivery.deliveryDate,
      "ddtNumber": delivery.ddtNumber,
      // "order": order + 1,
      "order": deletedOrder ? deletedOrder : order + 2,
      "status": delivery.status,
    });
    activityArray.push({
      "expert": delivery.expert.id,
      "activityType": "delivery",
      "delivery": delivery.id,
      "deliveryDate": delivery.deliveryDate,
      "ddtNumber": delivery.ddtNumber,
      // "order": deletedOrder ? deletedOrder : order + 2,
      "order": order + 1,
      "status": delivery.status,
    });
    return activityArray;
  }
  async buildActivityArray(delivery, order: number){
    let activityArray: any[] = [];
    if (delivery.serviceType.toLowerCase() === "sales" || delivery.serviceType.toLowerCase() === "fixedprice") {
      // if (delivery.startTime || delivery.fromTime) {
        activityArray.push({
          "expert": delivery.expert.id,
          "activityType": "pickup",
          "delivery": delivery.id,
          "deliveryDate": delivery.deliveryDate,
          "ddtNumber": delivery.ddtNumber,
          "order": order + 1,
          "status": delivery.status,
        });
      // }
      // if (delivery.pickUpTime) {
        activityArray.push({
          "expert": delivery.expert.id,
          "activityType": "delivery",
          "delivery": delivery.id,
          "deliveryDate": delivery.deliveryDate,
          "ddtNumber": delivery.ddtNumber,
          "order": order + 2,
          "status": delivery.status,
        });
      // }
    }

    if (delivery.serviceType.toLowerCase() === "hourlyrate") {
      activityArray.push({
        "expert": delivery.expert.id,
        "activityType": "hourlyservice",
        "delivery": delivery.id,
        "deliveryDate": delivery.deliveryDate,
        "ddtNumber": delivery.ddtNumber,
        "order": order + 1,
        "status": delivery.status,
      });
    }

    return activityArray;
  }

  async checkForExpertDeliveryRule(delivery: Delivery) {
    try {
      if(delivery.serviceType?.toLowerCase() === 'sales' && delivery?.ddtNumber) {
        let expertRule: ExpertDeliveryRulesSchema = await this.expertDeliveryRulesService.getOneExpertDeliveryRuleWithExpert(delivery?.expert?.id);
        let associateExpertsRule = await this.expertDeliveryRulesService.getAssociateExpertDeliveryRule(delivery?.expert?.id);
        if(expertRule) {
          await this.applyExpertDeliveryRule(expertRule, delivery);
          return;
        } 
        if(associateExpertsRule && associateExpertsRule?.expertDeliveryRule) {
          await this.applyExpertDeliveryRule(associateExpertsRule?.expertDeliveryRule, delivery);
          return;
        }
      }
      return;
    } catch (error) {
      console.log("ERROR", error);
    }
  }

  async applyExpertDeliveryRule(expertRule: ExpertDeliveryRulesSchema, delivery: Delivery) {
    let rules = expertRule.rules && typeof expertRule.rules === 'string' ? JSON.parse(expertRule.rules) : [];
    if(rules.length) {
      let pickUpActivities = await this.adminValetActivityService.getActivitiesWithDdtNumber(delivery);
      if(pickUpActivities.length >= 2) {
        for(let item of rules) {
          let pickUps  = item.pickUps; 
          if (compareValues(pickUpActivities.length, pickUps, item.operator.toLowerCase())) {
            console.log('Matched rule!', item);

            for (let activity of pickUpActivities) {
              const currentDelivery: Delivery = activity.delivery;
              /* Apply salary rule to the current delivery only if it matches the delivery triggering this logic */
              if (currentDelivery.id === delivery.id) {
                await this.deliveryService.update(currentDelivery.id, {
                  id: currentDelivery.id,
                  valetAdditionalPrice: String(item.plusSalary),
                  expertRuleId: expertRule.id,
                  payable: true
                });
              } else {
                /* All other related deliveries should be payable: false */
                const updatePayload: any = {
                  id: currentDelivery.id,
                  payable: false,
                  expertRuleId: expertRule.id
                };
              
                if (!currentDelivery.expertRuleId) {
                  updatePayload.valetAdditionalPrice = String(item.plusSalary);
                }
              
                await this.deliveryService.update(currentDelivery.id, updatePayload);
              }
            }
            break;
          } else {
            console.log('Rule not Matched!');
          }
        }
      }
    }
  }

  async changeActivityOrderAccordingTime(activities){
    
    try {
      let newActivityArray = [];
      activities.forEach((activity: any) => {
        if (activity.activityType.toLowerCase() === "pickup") {
          newActivityArray.push({
            ...activity,
            timing: activity.delivery?.pickUpTime.split('-')[0]
          });
        }
        if (activity.activityType.toLowerCase() === "delivery") {
          newActivityArray.push({
            ...activity,
            timing: activity.delivery?.fromTime
          });
        }
        if (activity.activityType.toLowerCase() === "hourlyservice") {
          newActivityArray.push({
            ...activity,
            timing: activity.delivery.startTime ? activity.delivery.startTime : activity.delivery.fromTime ? activity.delivery.fromTime : ''
          });
        }
      });
  
      newActivityArray.sort((a, b) => {
        const timeA = a.timing.split(':').map(Number); 
        const timeB = b.timing.split(':').map(Number); 
        return timeA[0] - timeB[0] || timeA[1] - timeB[1];
      });
  
      newActivityArray.forEach((activity, i) => {
        activity.order = i + 1;
      });
  
      const resultArray = newActivityArray.map(activity => ({
        id: activity.id,
        order: activity.order
      }));
      
      await this.adminValetActivityService.updateActivityOrder(resultArray);
    } catch (error) {
      console.log("ERROR", error);
    }
  }

  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }
}
